import React from "react";
import { PartnerCard } from "./ui/partner-card";
import { Flex } from "@radix-ui/themes";
import { BlueField } from "./ui/blue-field";

export function Syngenta() {
  return (
    <PartnerCard
      logo={
        <img
          className="partner-logo"
          src="/Images/barometer/2025/massMediaLogos/syngenta-logo.png"
          alt="partner logo"
        />
      }
      heading="Експертний Галузевий партнер"
    >
      <Flex direction="column" gap="5">
        <p>
          <BlueField>Syngenta – провідна агрохімічна компанія, </BlueField> яка
          прагне підвищити рівень продовольчої безпеки у світі, даючи можливість
          мільйонам сільгоспвиробників раціональніше використовувати наявні
          ресурси. Завдяки передовим науковим знанням та інноваційним рішенням,
          28 000 фахівців у понад 90 країнах світу працюють з метою вдосконалити
          сучасні підходи до вирощування рослин
        </p>

        <p>
          <BlueField>
            Syngenta є одним із лідерів світового агробізнесу, що оцінюється у
            понад 60 мільярдів доларів.{" "}
          </BlueField>{" "}
          До портфоліо компанії входять 80+ засобів захисту рослин, а також
          велика кількість гібридів і сортів насіння польових та овочевих
          культур
        </p>

        <p>
          В українському відділенні компанії працює близько 500 фахівців, серед
          яких багато кандидатів сільськогосподарських наук.
          <BlueField>
            {" "}
            Метою компанії є пропозиція комплексних рішень для українських
            аграріїв та партнерство з українськими та міжнародними компаніями
          </BlueField>
        </p>

        <p>
          Syngenta рішуче налаштована зберегти родючі землі від деградації,
          сприяти підвищенню біорозмаїття та відродженню сільських громад
        </p>
      </Flex>
    </PartnerCard>
  );
}
